import { render, staticRenderFns } from "./ProjectFilesPanel.vue?vue&type=template&id=ff652e4a&scoped=true"
import script from "./ProjectFilesPanel.vue?vue&type=script&lang=js"
export * from "./ProjectFilesPanel.vue?vue&type=script&lang=js"
import style0 from "./ProjectFilesPanel.vue?vue&type=style&index=0&id=ff652e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff652e4a",
  null
  
)

export default component.exports